import React, { useState } from "react";
import FaBookmark from "../../assets/icons/bookmark";
import FaRegBookmark from "../../assets/icons/bookmarkOutline";
import { storyDetailsRoute } from "../../routes/routesPath";
import { getSlug, handleLoginPop } from "../../utils/helpers";
import useAuth from "../../hooks/useAuth";
import { manageBookmark } from "../../redux/bookmarks/thunk";
import { handleApiRequest } from "../../services/handleApiRequest";
import AddReaction from "../common/addReaction";
import StoryCardHeader from "./storyCardHeader";
import ReportStoryPop from "../Modals/reportStoryPop";
import SharePop from "../Modals/sharePop";

export default function StoryCard({ story = {}, showReaction = "", setShowReaction }) {
  const { isAuthenticated } = useAuth();
  const [storyDetails, setStoryDetails] = useState({ ...story });
  const [userAction, setUserAction] = useState(null);

  const handleBookmark = async (e) => {
    e.stopPropagation();
    if (!isAuthenticated) return handleLoginPop(true);

    setStoryDetails((prev) => ({ ...prev, isBookmarked: !prev.isBookmarked }));

    const response = await handleApiRequest(manageBookmark, { storyId: storyDetails._id });
    if (!response.status) {
      setStoryDetails((prev) => ({ ...prev, isBookmarked: !prev.isBookmarked }));
    }
  };

  return (
    <>
      <div
        className="mainStoryCard rounded mb-3 pointer p-2 p-lg-3 m-1"
        onClick={() =>
          window.open(`${storyDetailsRoute}/${getSlug(storyDetails.title)}/${storyDetails._id}`)
        }>
        <StoryCardHeader story={storyDetails} showStatus={false} setUserAction={setUserAction} />

        <h3 className="h5 mt-3 mb-2 truncate-1">{storyDetails.title}</h3>
        <div
          className="storyDesc truncate-3"
          dangerouslySetInnerHTML={{ __html: storyDetails.description }}
        />

        <div className="storyAction d-flex align-items-center justify-content-between mt-3">
          <div className="d-flex align-items-center">
            <p
              className="min-w-50 btn justify-content-center me-2 bg-header border-secondary-light me-2 px-2 ps-sm-2 pe-sm-3 py-1 py-2 rounded-pill text-small"
              onClick={(e) => e.stopPropagation()}>
              <span
                dangerouslySetInnerHTML={{ __html: storyDetails.category?.iconFilled }}
                className="reactedIcon"
              />
              <span className="d-none d-sm-inline-block">{storyDetails.category?.name}</span>
            </p>
            <div className="position-relative me-2">
              <AddReaction
                showReaction={showReaction}
                setShowReaction={setShowReaction}
                savedReaction={storyDetails.myReaction}
                reactionsCount={storyDetails?.reactionsCount}
                storyId={storyDetails._id}
                setStoryDetails={setStoryDetails}
              />
            </div>
            <button
              className="mainStoryCardAction min-w-50 mx-0 justify-content-center bg-header border-secondary-light me-2 px-2 ps-sm-2 pe-sm-3 py-2 rounded-pill text-small"
              onClick={handleBookmark}>
              {storyDetails.isBookmarked ? (
                <>
                  <span>
                    <FaBookmark className="icon-small" />
                  </span>
                  <span className="d-none d-sm-inline-block">Unsave</span>
                </>
              ) : (
                <>
                  <span>
                    <FaRegBookmark className="icon-small" />
                  </span>
                  <span className="d-none d-sm-inline-block">Save</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {userAction?.action === "reportStory" && (
        <ReportStoryPop userAction={userAction} setUserAction={setUserAction} />
      )}

      {userAction?.action === "showSharePop" && (
        <SharePop
          userAction={userAction}
          setUserAction={setUserAction}
          title="Share Story"
          link={window.location.href}
        />
      )}
    </>
  );
}
